import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { useI18n } from "@/i18n";
import { useDownload } from "@/hooks/useDownload";
import { useEffect } from "react";
import { AiFillApple } from "react-icons/ai";
import { PlayIcon } from "@/components/landing/parts";
import { Lines, fill, useLanding } from "@/components/landing/i18n";

const Hero = ({ onWatchFilm }: { onWatchFilm: () => void }) => {
  const { language } = useI18n();
  const { isLoading, downloadLatest, latestVersion, getVersionInfo } = useDownload();
  const { t } = useLanding();
  const h = t.hero;

  useEffect(() => {
    getVersionInfo();
  }, [getVersionInfo]);

  const badges = [h.badges.free, h.badges.offline, 'Apple Silicon, 16GB+'];

  return (
    <section className="hero">
      <div className="wrap">
        <div className="hero-inner">
          {/* Version comes from the release API, so it updates itself with every release. */}
          {latestVersion?.version && (
            <span className="hero-pill r">
              <b>v{latestVersion.version.replace(/^v/i, "")}</b>
              {h.pill}
            </span>
          )}
          <h1 className="h1 r">
            <Lines text={h.titlePre} /><mark><Lines text={h.titleMark} /></mark><Lines text={h.titlePost} />
          </h1>
          <p className="hero-sub r">{fill(h.sub)}</p>

          <div className="cta-row r">
            <Button
              size="lg"
              className="text-base px-8 bg-[#1E88C8] hover:bg-[#1670A8] text-white shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5"
              onClick={downloadLatest}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Loader2 className="mr-2 animate-spin" />
                  {language === 'en' ? 'Loading...' : '加载中...'}
                </>
              ) : (
                <>
                  <AiFillApple className="mr-1" />
                  {language === 'en' ? 'Download for Mac' : '下载 Mac 版'}
                </>
              )}
            </Button>
            <button className="btn-film boxed" onClick={onWatchFilm}>
              <i><PlayIcon /></i>
              {h.watch}
            </button>
          </div>

          <p className="hero-facts r">
            {badges.map((b, i) => <span key={b}>{i > 0 && <em aria-hidden>·</em>}{b}</span>)}
          </p>
        </div>

      </div>
    </section>
  );
};

export default Hero;
